module.exports = __webpack_public_path__ + "img/wizard-background.f0005d6b.jpg";